import api from '@/services/api'
import type {
  UserPaymentCreateRequest,
  UserPaymentResponse,
  UserPaymentListResponse,
  PaymentServicesAvailabilityResponse,
  PaymentMethodListResponse,
} from './types'

export const PaymentsV2Service = {
  getPaymentMethods() {
    return api.get<PaymentMethodListResponse>('/v2/payments/payment-methods')
  },
  getAvailableServices() {
    return api.get<PaymentServicesAvailabilityResponse>('/v2/payments/available-services')
  },
  getLastPayment() {
    return api.get<UserPaymentResponse>('/v2/payments/last')
  },
  getPaymentById(paymentId: number) {
    return api.get<UserPaymentResponse>(`/v2/payments/${paymentId}`)
  },
  getPayments() {
    return api.get<UserPaymentListResponse>('/v2/payments')
  },
  createPayment(data: UserPaymentCreateRequest) {
    return api.post<UserPaymentResponse>('/v2/payments', data)
  },
  cancelPayment(paymentId: number) {
    return api.put(`/v2/payments/${paymentId}/cancel`)
  },
}
